import * as LiveApi from "@/DataAdapter/Portal/LiveApi"
import * as NodeDiagramApi from "@/DataAdapter/Portal/NodeDiagramApi"
import * as ArchiveApi from "@/DataAdapter/Portal/ArchiveApi"
import * as ChecklistApi from "@/DataAdapter/Portal/ChecklistApi"

export const SATOSPortalNew = {
    ...LiveApi,
    ...ArchiveApi,
    ...NodeDiagramApi,
    ...ChecklistApi
}